import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import {
  CreateEntityDocumentSubCategoryBody,
  EntityDocumentSubCategoryApi,
  FilterEntityDocumentSubCategoryOption,
  UpdateEntityDocumentSubCategoryBody,
} from 'api';

import { RootState } from '../app';

export const findEntityDocumentSubCategory = createAsyncThunk(
  'entityDocumentSubCategory/findEntityDocumentSubCategory',
  async (option: any, { rejectWithValue }) => {
    try {
      const response = await EntityDocumentSubCategoryApi.findWithEntity();

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findOneEntityDocumentSubCategory = createAsyncThunk(
  'entityDocumentSubCategory/findOneEntityDocumentSubCategory',
  async (params: any, { rejectWithValue }) => {
    try {
      const { id, option } = params;
      const response = await EntityDocumentSubCategoryApi.findOne(id, option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const findDocumentSubCategoryByEntity = createAsyncThunk(
  'entityDocumentSubCategory/findDocumentSubCategoryByEntity',
  async (option: any, { rejectWithValue }) => {
    try {
      const response = await EntityDocumentSubCategoryApi.findWithEntity();

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const filterEntityDocumentSubCategory = createAsyncThunk(
  'entityDocumentSubCategory/filterEntityDocumentSubCategory',
  async (
    option: FilterEntityDocumentSubCategoryOption,
    { rejectWithValue }
  ) => {
    try {
      const response = await EntityDocumentSubCategoryApi.filter(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const createEntityDocumentSubCategory = createAsyncThunk(
  'entityDocumentSubCategory/createEntityDocumentSubCategory',
  async (body: CreateEntityDocumentSubCategoryBody, { rejectWithValue }) => {
    try {
      const response = await EntityDocumentSubCategoryApi.create(body);
      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

export const updateEntityDocumentSubCategory = createAsyncThunk(
  'entityDocumentSubCategory/updateEntityDocumentSubCategory',
  async (
    params: {
      id: string;
      body: UpdateEntityDocumentSubCategoryBody;
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await EntityDocumentSubCategoryApi.update(params);
      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

export const removeEntityDocumentSubCategory = createAsyncThunk(
  'entityDocumentSubCategory/removeEntityDocumentSubCategory',
  async (body: any, { rejectWithValue }) => {
    try {
      const response = await EntityDocumentSubCategoryApi.remove(body);
      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

interface IState {
  list: Array<any>;
  listAll: Array<any>;
  isInitData: boolean;
  entityDocumentSubCategoriesHash: any;
}

const initialState: IState = {
  list: [],
  listAll: [
    {
      key: 'all',
      value: 'all',
      name: 'Tất cả chứng từ',
    },
  ],
  isInitData: false,
  entityDocumentSubCategoriesHash: {},
};

const entityDocumentSubCategorySlice = createSlice({
  name: 'entityDocumentSubCategory',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(
      findEntityDocumentSubCategory.fulfilled,
      (state, action) => {
        const { data } = action.payload;

        (data || []).forEach((e: any) => {
          const subCategories = e.subCategories?.map((item: any) => {
            return {
              ...item,
              key: item.id,
              value: item.id,
            };
          });

          state.entityDocumentSubCategoriesHash[e.id] = subCategories;
        });

        const newData = (data || []).map((item: any) => {
          return {
            ...item,
            key: item.id,
            value: item.id,
          };
        });

        state.list = newData;

        state.listAll = [
          {
            key: 'all',
            value: 'all',
            name: 'Tất cả chứng từ',
          },
          ...newData,
        ];

        state.isInitData = true;
      }
    );
  },
});

const { reducer: entityDocumentSubCategoryReducer } =
  entityDocumentSubCategorySlice;

export default entityDocumentSubCategoryReducer;

export const selectEntityDocumentSubCategory = (state: RootState): IState =>
  state.entityDocumentSubCategory as IState;
